var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaisse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_2903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9169 8.66694C24.3179 8.66694 23.8336 9.15119 23.8336 9.75027V15.8018L16.7237 8.69294C15.2677 7.23694 12.8984 7.23694 11.4424 8.69294L8.65069 11.4847C8.06244 12.0729 7.10369 12.0729 6.51544 11.4847L1.84952 6.81769C1.42594 6.3941 0.741271 6.3941 0.317688 6.81769C-0.105896 7.24127 -0.105896 7.92594 0.317688 8.34952L4.98469 13.0165C6.41685 14.4487 8.75144 14.4487 10.1836 13.0165L12.9754 10.2248C13.5864 9.61377 14.5809 9.61377 15.1929 10.2248L22.3018 17.3336H16.2503C15.6512 17.3336 15.1669 17.8179 15.1669 18.4169C15.1669 19.016 15.6512 19.5003 16.2503 19.5003H22.7503C24.5421 19.5003 26.0003 18.0421 26.0003 16.2503V9.75027C26.0003 9.15119 25.516 8.66694 24.9169 8.66694Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_2903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaisse);
export default __webpack_public_path__ + "static/media/baisse.f7215513bcfb37740fc5ae5014d89f3c.svg";
export { ForwardRef as ReactComponent };